import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";

import { CalendarConfig, SystemSettingConfig } from "src/services/config";

interface ConfigState {
  calendarConfig: CalendarConfig | null;
  systemSettingConfig: SystemSettingConfig[] | null;
  setCalendarConfig: (config: CalendarConfig) => void;
  setSystemSettingConfig: (config: SystemSettingConfig[]) => void;
}

export const useConfigStore = create<ConfigState>()(
  devtools(
    persist(
      (set) => ({
        calendarConfig: null,
        systemSettingConfig: null,
        setCalendarConfig: (config) => set({ calendarConfig: config }),
        setSystemSettingConfig: (config) => set({ systemSettingConfig: config }),
      }),
      {
        name: "config-storage",
      }
    )
  )
); 